import React, { useState } from 'react';
import { Modal, Typography, Button, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

const { Title } = Typography;

const AIUsageInfo = ({ styles = {} }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title="AI Usage Guidelines" getPopupContainer={() => document.body} // ensures correct layering
styles={{ root: { zIndex: 1302 } }}>
        <Button
          className=''
          type="text"
          onClick={() => setOpen(true)}
          style={{ padding: '0 5px' }}
        >
        <InfoCircleOutlined style={{ fontSize: 20, padding: '0 5px', color: '#1890ff',position: 'relative', zIndex: 1000, ...styles.icon }} />
        </Button>
      </Tooltip>

      <Modal
        className='AiInfoModalIndex'
        open={open}
        onCancel={() => setOpen(false)}
        zIndex={999999999}
        footer={[
          <Button
            key="acknowledge"
            type="primary"
            size="large"
            style={{
              borderRadius: '8px',
              padding: '4px 20px',
              backgroundColor: '#002d75',
              border: 'none',
            }}
            onClick={() => setOpen(false)}
          >
            I Acknowledge
          </Button>,
        ]}
        width={620}
        bodyStyle={{ padding: '24px 32px' }}
        style={{ borderRadius: '12px', top: 60 }}
        title={
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <img
              src="https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/Logos%2Flogo_transparent.png?alt=media&token=b0871bf7-069c-4906-9884-68f981cf7ef2"
              alt="Logo"
              style={{ height: 50, objectFit: 'contain' }}
            />
            <div style={{ flex: 1, textAlign: 'center', marginRight: 50 }}>
              <Title level={4} style={{ margin: 0, fontWeight: 600 }}>
                AI Usage Guidelines
              </Title>
            </div>
          </div>
        }
      >
        <ul style={{ paddingLeft: 18, lineHeight: 1.8, fontSize: 15 }}>
          <li>
            <strong>Review for Accuracy:</strong> AI-generated content may occasionally be incorrect
            or biased. Always verify information before using it with students.
          </li>
          <li>
            <strong>Refine with the 60/40 Rule:</strong> Let AI handle the first 60% of the work.
            You provide the final 40%—polishing, reviewing, and tailoring the content to your
            specific context.
          </li>
          <li>
            <strong>Exercise Professional Judgment:</strong> Treat AI output as a draft or starting
            point. Your expertise should guide the final decision.
          </li>
          <li>
            <strong>Respect Privacy:</strong> Never include identifiable student data such as names
            or addresses. All personal data is removed when detected.
          </li>
        </ul>
      </Modal>
    </>
  );
};

export default AIUsageInfo;
